import axios from 'axios';

export const DCVB_API_URL = process.env.VUE_APP_DCVB_API_URL;

export function fetchEntries({ page = '1', text, op }) {
  const url = `${DCVB_API_URL}?id_request=cerca_simple&page=${page}&texte_entrada=${text}`;

  const fullUrl = op ? `${url}&op=${op}` : url;
  return axios({
    url: fullUrl,
    method: 'GET',
  }).then((response) => response.data);
}

export function fetchEntry({ entryId }) {
  return axios({
    url: `${DCVB_API_URL}?id_request=obtenir_entrada&id_entrada=${entryId}`,
    method: 'GET',
  }).then((response) => response.data);
}

export function advSearchByFreeText({
  page, freeText, params, op,
}) {
  const url = `${DCVB_API_URL}?id_request=cerca_avancada_free_text&page=${page}&free_text=${freeText}&${params}`;

  const fullUrl = op ? `${url}&op=${op}` : url;
  return axios({
    url: fullUrl,
    method: 'GET',
  }).then((response) => response.data);
}

export function advSearchByTags({ page, params }) {
  return axios({
    url: `${DCVB_API_URL}?id_request=cerca_avancada_etiquetes&page=${page}&${params}`,
    method: 'GET',
  }).then((response) => response.data);
}

export function fetchImgTblEntries({
  entryText, img, tbl,
}) {
  return axios({
    url: `${DCVB_API_URL}?id_request=obtenir_entrades_amb_img_tbl&img=${img}&tbl=${tbl}&texte_entrada=${entryText}&op=starts_with`,
    method: 'GET',
  }).then((response) => response.data);
}

export function advSearchByImgTbl({
  page, entryText, img, tbl,
}) {
  return axios({
    url: `${DCVB_API_URL}?id_request=obtenir_entrades_amb_img_tbl&img=${img}&tbl=${tbl}&page=${page}&texte_entrada=${entryText}`,
    method: 'GET',
  }).then((response) => response.data);
}

export function fetchSelectorsTags() {
  return axios({
    url: `${DCVB_API_URL}?id_request=selectors_etiquetes`,
    method: 'GET',
  }).then((response) => response.data);
}

export function fetchLetterEntriesCount() {
  return axios({
    url: `${DCVB_API_URL}?id_request=get_letter_entries_count`,
    method: 'GET',
  }).then((response) => response.data);
}
